import { useId } from 'react'
import { cn } from '@/lib/cn'

type Props = React.InputHTMLAttributes<HTMLInputElement> & { label: string }

export default function Field({ label, className, ...props }: Props) {
  const id = useId()
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={id} className="eyebrow">
        {label}
      </label>
      <input
        id={id}
        className={cn(
          'bg-card border-rule-strong text-ink rounded-row border px-4 py-3.5 text-body',
          'placeholder:text-ink-dim focus:border-field outline-none',
          className
        )}
        {...props}
      />
    </div>
  )
}
